import React from 'react';
import { ModalProps } from '../ModalFactory';
import { Modal } from '@mui/material';
import styles from '../ModalFactory.module.css';

type ModalSize = 'small' | 'medium' | 'large';

const ModalCustomSize: React.FC<{
  modalSize: ModalSize;
  children: React.ReactNode;
  props: ModalProps;
}> = ({ children, modalSize, props: { onClose } }) => {
  let customWidth = '100px';
  let customHeight = '100px';

  switch (modalSize) {
    case 'small':
      customWidth = '400px';
      customHeight = '300px';
      break;
    case 'medium':
      customWidth = '604px';
      customHeight = '338px';
      break;
    // Add more cases as needed
    default:
      break;
  }

  return (
    <Modal aria-labelledby='modal-modal-title' aria-describedby='modal-modal-description' open onClose={onClose}>
      <div className={styles.ModalContainer} style={{ width: customWidth, minHeight: customHeight }}>
        {children}
      </div>
    </Modal>
  );
};

export default ModalCustomSize;
